"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const class_validator_1 = require("class-validator");
// tslint:disable-next-line:no-any
class CommonEventRequest {
    constructor(event) {
        if (event) {
            this.source = event.source;
            this.type = event.type;
            this.subType = event.subType;
            this.partner = event.partner;
            this.tags = event.tags;
            this.identities = event.identities;
            this.dateTime = event.dateTime;
            this.data = event.data;
            this.metadata = event.metadata;
        }
    }
}
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], CommonEventRequest.prototype, "source", void 0);
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], CommonEventRequest.prototype, "type", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsString(),
    __metadata("design:type", String)
], CommonEventRequest.prototype, "subType", void 0);
__decorate([
    class_validator_1.IsString(),
    __metadata("design:type", String)
], CommonEventRequest.prototype, "partner", void 0);
__decorate([
    class_validator_1.IsOptional(),
    class_validator_1.IsArray(),
    __metadata("design:type", Array)
], CommonEventRequest.prototype, "tags", void 0);
__decorate([
    class_validator_1.IsOptional(),
    __metadata("design:type", Object)
], CommonEventRequest.prototype, "identities", void 0);
__decorate([
    class_validator_1.IsOptional(),
    __metadata("design:type", Object)
], CommonEventRequest.prototype, "metadata", void 0);
__decorate([
    class_validator_1.IsDateString(),
    __metadata("design:type", String)
], CommonEventRequest.prototype, "dateTime", void 0);
__decorate([
    class_validator_1.IsDefined(),
    __metadata("design:type", Object)
], CommonEventRequest.prototype, "data", void 0);
exports.CommonEventRequest = CommonEventRequest;



// WEBPACK FOOTER //
// ./node_modules/@soluto-private/common-event/dist/src/models/index.js